import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';

import { CircleExclamation } from '../../assets/svg/CircleExclamation';
import { formatDecimal } from '../../helpers/formatDecimal';
import { selectSettings } from '../../store/settings/settingsStore';
import { Container, TextStyles, ValueStyles } from './Information.styles';

type Props = {
    name: string;
    value: string | number | undefined;
    icon?: boolean;
};

const InformationRow = ({ name, value, icon }: Props) => {
    const { countryCode } = useSelector(selectSettings);
    return (
        <Grid container sx={Container} spacing={'16px'}>
            <Grid size={6} sx={TextStyles}>
                {icon && <CircleExclamation />}
                <span>{name}</span>
            </Grid>
            <Grid size={6} sx={ValueStyles}>
                <span>{formatDecimal(value, countryCode)}</span>
            </Grid>
        </Grid>
    );
};

export default InformationRow;
